import React from 'react';

import { FormattedMessage, IntlShape } from 'react-intl';

import { ReactTableEnums, CoreCommonMessages, CoreUtils } from '@nhl/nhl-breakaway-ui';
import { ColumnDef, ColumnHelper, createColumnHelper } from '@tanstack/react-table';

import CommonMessages from '~/core/commonMessages';

import { CommonGCGame, PeriodValue } from '../../types';

type ColumnPeriod = PeriodValue & {
    isFuturePeriod?: boolean;
    isTotal?: boolean;
};

const columnWidth = 40;
const columnHelper: ColumnHelper<ColumnPeriod> = createColumnHelper<ColumnPeriod>();

const columnMeta = {
    headerStyle: 'text-align: center',
    style: `text-align: center;`,
};

export const createColumns = (game: CommonGCGame, intl: IntlShape): Array<ColumnDef<ColumnPeriod>> => {
    const columns: Array<ColumnDef<ColumnPeriod>> = [];

    columns.push(
        columnHelper.display({
            id: 'total',
            size: columnWidth,
            header: () => <FormattedMessage {...CoreCommonMessages.gamePeriodDescriptions.long.periodText} />,
            cell: (data) =>
                data.row.original.isTotal ? (
                    <FormattedMessage
                        description="A word describing the total amount of goals a team has"
                        defaultMessage="Total"
                    />
                ) : (
                    CoreUtils.getPeriodDisplayFromDescriptor(intl, data.row.original.periodDescriptor, game.gameType)
                ),
            meta: {
                ...columnMeta,
                scope: ReactTableEnums.Scopes.ROW,
            },
        })
    );

    columns.push(
        columnHelper.display({
            id: 'awayTeam',
            size: columnWidth,
            header: () => game.awayTeam.abbrev,
            cell: (data) =>
                data.row.original.isFuturePeriod ? (
                    <FormattedMessage {...CommonMessages.statsDescriptions.noStatIndicator} />
                ) : (
                    data.row.original.away
                ),
            meta: columnMeta,
        })
    );

    columns.push(
        columnHelper.display({
            id: 'homeTeam',
            size: columnWidth,
            header: () => game.homeTeam.abbrev,
            cell: (data) =>
                data.row.original.isFuturePeriod ? (
                    <FormattedMessage {...CommonMessages.statsDescriptions.noStatIndicator} />
                ) : (
                    data.row.original.home
                ),
            meta: columnMeta,
        })
    );

    return columns;
};

export default [];
